// extracted by mini-css-extract-plugin
export var LineBreak = "introduction-module--LineBreak--3D8Vp";
export var Title1 = "introduction-module--Title1--1ntwh";
export var HtmlDiv = "introduction-module--HtmlDiv--3xY8M";
export var Button = "introduction-module--Button--2ip0h";
export var Carousel = "introduction-module--Carousel--2sz3x";
export var CarouselItem = "introduction-module--CarouselItem--1cEst";
export var CarouselImage = "introduction-module--CarouselImage--1Wdv_";
export var CarouselCaption = "introduction-module--CarouselCaption--tWMW1";
export var Video = "introduction-module--Video--HT1pL";
export var Video2 = "introduction-module--Video2--E4MjS";